import { Card, CardContent, Typography } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { PermissionsService } from '../../../../auth/services/PermissionsService';
import { Interpolation } from '../../../../config/i18n/components/Interpolation';
import { PATHS } from '../../../../routing/routes';

type Props = {
  withFilteredView: boolean;
};

export const BlankIssues = ({ withFilteredView }: Props) => {
  const [canDownloadTracer, setCanDownloadTracer] = useState<boolean>(false);

  useEffect(() => {
    const permissionsService = new PermissionsService();

    const loadPermissions = async () => {
      try {
        const canDownloadTracer = await permissionsService.canDownloadTracers();
        setCanDownloadTracer(canDownloadTracer);
      } catch {
        // do nothing
      }
    };

    loadPermissions();

    return () => permissionsService.cancelAllRequests();
  }, []);

  return (
    <Card elevation={0}>
      <CardContent sx={{ textAlign: 'center' }}>
        <Typography variant="h3" sx={{ py: 2, fontSize: '1.5rem' }}>
          {withFilteredView ? t('noResultsForCurrentFilters') : t('noResults')}
        </Typography>
        {canDownloadTracer && withFilteredView && (
          <Interpolation
            i18nKey={'emptyIssuesActionsSensors'}
            items={[{ name: 'anchor', tabIndex: 0, href: PATHS.SENSORS, target: '_blank' }]}
            sx={{ display: 'inline-block', maxWidth: '23.75rem', color: 'text.secondary' }}
            variant="body2"
          />
        )}
      </CardContent>
    </Card>
  );
};
